<vs-video-tutor *ngIf="displayVideoTour"></vs-video-tutor>
<!-- <vs-site-tour *ngIf="displaySiteTour"></vs-site-tour> -->
<vs-help-menu *ngIf="displayHelp"  (helpMenuClicked)="closeHelpMenu()"
></vs-help-menu> 
<div *ngIf="node$| async as nodeItem" class="help-menu-container">
    <div *ngFor="let node of nodeItem['children']">   
        <a *ngIf="node.title === 'Terms & Conditions'" class="help-menu-item" [href]="termsLink" target="_blank">{{node.title}}</a>
        <a *ngIf="node.title !== 'Terms & Conditions'" class="help-menu-item" (click)="helpCall(node)">{{node.title}}</a>
    </div>
</div>